import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../data/services/auth.service';
import { SessionService } from '../../../../core/services/session.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login {
  private readonly fb = inject(FormBuilder);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly sessionService = inject(SessionService);

  isSubmitting = false;
  errorMessage = '';

  readonly form = this.fb.group({
    emailOrUsername: ['', [Validators.required]],
    password: ['', [Validators.required, Validators.minLength(6)]]
  });

  get emailOrUsernameControl() {
    return this.form.get('emailOrUsername');
  }

  get passwordControl() {
    return this.form.get('password');
  }

  onLogin(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';

    this.authService.login({
      emailOrUsername: (this.form.value.emailOrUsername ?? '').trim(),
      password: this.form.value.password ?? ''
    }).subscribe({
      next: (response) => {
        this.isSubmitting = false;

        if (!response.success) {
          this.errorMessage = response.message || 'Login failed.';
          return;
        }

        if (this.sessionService.isSuperAdmin() || this.sessionService.isCompanyAdmin()) {
          this.router.navigate(['/app/dashboard']);
        } else {
          this.router.navigate(['/app/jobs']);
        }
      },
      error: (error) => {
        this.isSubmitting = false;

        this.errorMessage =
          error?.error?.message ||
          error?.message ||
          'Unable to login. Please try again.';
      }
    });
  }
}